module.exports = __webpack_public_path__ + "img/bot1.c13d89aa.svg";